<template>
    <textarea type="text"
              class="text-area form-control"
              v-model="content"
              @focus="$emit('focus', $event)"
              :disabled="disabled"
    />
</template>

<script>

    export default {
        props: {
            value: String,
            disabled: {type: Boolean, default: false},
        },

        computed: {
            content: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
        },

        methods: {
            fixHeight() {
                this.$el.style.height = "5px";
                this.$el.style.height = this.$el.scrollHeight + "px";
            },
        },

        mounted() {
            this.fixHeight();
        },

        watch: {
            async value() {
                await this.$nextTick();
                this.fixHeight();
            },
        },
    };
</script>